import EnrolmentsSerializer from './base';

export default class Status extends EnrolmentsSerializer {}
